import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';

import { useCheckoutContext } from '@zooplus/checkout-state';
import { Email } from '@zooplus/icons';
import { Anchor, Checkbox, FlatBox, P1 } from '@zooplus/ui-components';

import usePageTracking from '@hooks/use-adobe-tracking/use-page-tracking';
import { useTranslation } from '@hooks/use-translations';
import {
  CHECKOUT_STATE_PROJECT_ID,
  TARGET_ACTION_ID,
  TARGET_COMPONENT_NAME,
  TRACKING_DATA_EVENT,
} from '@utilities/constants';

import styles from './newsletter-subscription.module.scss';

export const NEWSLETTER_CHECKBOX_ID = 'newsletterSubscriptionCheckbox';

const NewsletterSubscription = () => {
  const { t } = useTranslation();
  const { trackEventUsingTrackerListener } = usePageTracking();
  const { checkoutState } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const [isChecked, setIsChecked] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCheckboxChange = useCallback(() => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);
  }, [isChecked]);

  const toggleExpansion = useCallback(() => {
    setIsExpanded((prevState) => !prevState);
  }, []);

  useEffect(() => {
    if (isChecked) {
      trackEventUsingTrackerListener(
        TRACKING_DATA_EVENT.CLICK,
        TARGET_ACTION_ID.NEWSLETTER_CHECKED,
        TARGET_COMPONENT_NAME.NEWSLETTER,
      );
    }
  }, [isChecked, trackEventUsingTrackerListener]);

  const { isSubscribedToNewsletter = false } = checkoutState?.customer || {};
  if (isSubscribedToNewsletter) {
    return null;
  }

  return (
    <FlatBox
      variant="white"
      className={classNames(styles.newsletterCheckboxContainer, 'pp-mt-2xl')}>
      <FlatBox
        rounded
        variant="white"
        data-testid={`${NEWSLETTER_CHECKBOX_ID}ContainerTestId`}
        className={styles.wrapperContainer}>
        <div className={styles.checkboxWrapper}>
          <P1 bold>{t('checkout.newsletter.title')}</P1>
          <div className={styles.description}>
            <Checkbox
              id={NEWSLETTER_CHECKBOX_ID}
              data-testid={`${NEWSLETTER_CHECKBOX_ID}TestId`}
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <div className={styles.labelContainer}>
              <span
                className={isExpanded ? styles.expanded : ''}
                dangerouslySetInnerHTML={{
                  __html: t('checkout.newsletter.minimum.description'),
                }}
              />
              {!isExpanded && (
                <>
                  {' '}
                  <Anchor onClick={toggleExpansion} className={styles.seeMoreLink}>
                    {t('checkout.newsletter.description.see.more')}
                  </Anchor>
                </>
              )}
            </div>
          </div>
        </div>
        <div className={styles.letterIcon}>
          <Email />
        </div>
      </FlatBox>
    </FlatBox>
  );
};

export default NewsletterSubscription;
